/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import DocsLayout from '../../components/DocsLayout';
import NextPage from '../../components/NextPage';
import Primary from '../../sections/api/primary/index.mdx';
import Helpers from '../../sections/api/helpers/index.mdx';
import SupportedCSS from '../../sections/api/supported-css.mdx';
import TypeScript from '../../sections/api/typescript.mdx';
import OldAPIs from '../../sections/api/old/index.mdx';
import TestUtilities from '../../sections/api/test-utils/index.mdx';
const MDXLayout = ({children}) => _jsx(DocsLayout, {
  title: "API 参考",
  description: "styled-components 的 API 参考",
  children: children
});
function _createMdxContent(props) {
  return _jsxs(_Fragment, {
    children: [_jsx(Primary, {}), "\n", _jsx(Helpers, {}), "\n", _jsx(TestUtilities, {}), "\n", _jsx(SupportedCSS, {}), "\n", _jsx(TypeScript, {}), "\n", _jsx(OldAPIs, {}), "\n", _jsx(NextPage, {
      href: "/docs/tooling",
      title: "工具"
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
